import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { debugLog } from "../../utils/helpers";

const SelectionHeader = ({
  adminStatus,
  city_id,
  setCity_id,
  cityOptions,
  isSchoolAdmin,
  isRecorder,
  isSelPanel,
  canDriveSelection,
  handleCityChange,
  handleClientsUpdate,
  handleResetState,
  navigate,
  location,
  socket,
}) => {

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Typography variant="h5">Scholarship Selection</Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel id="city-select-label">Select City</InputLabel>
              <Select
                labelId="city-select-label"
                label="Select City"
                value={city_id}
                onChange={handleCityChange}
              >
                {cityOptions.map((city) => (
                  <MenuItem key={city.id} value={city.id}>
                    {city.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

        {canDriveSelection ? (
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={handleClientsUpdate}
            >
              Push
            </Button>
            
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleResetState}
            >
              Reset
            </Button>
          </>
        ) : (
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {/* <Typography variant="body1">
              {cityOptions.find((city) => city.id === city_id)?.name}
            </Typography> */}
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                debugLog("📡 Manual pull request from school admin and SelPanel", city_id);
                socket.emit("schoolAdminLoad", {city_id});
              }}
            >
              Sync
            </Button>
          </Box>
        )}
        {location.pathname === "/admin" ? (
          <IconButton color="primary" onClick={() => navigate("/selcom")}>
            <FullscreenIcon />
          </IconButton>
        ) : (
          <IconButton
            color="secondary"
            onClick={() => navigate(`/admin?nav=selcom`)}
          >
            <FullscreenExitIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default SelectionHeader;
